(() => {
  const scope = '#MainContent, footer, .footer';
  const copy = 'p,h1,h2,h3,h4,h5,h6,blockquote,li,.rte > div,[data-vyv-wrap]';
  const excluded = 'nav,form,button,input,textarea,select,[contenteditable],svg,script,style,[aria-hidden="true"],.visually-hidden,.sr-only,.vyv-shop-hero__facts';
  let endings = [];
  let frame = 0;
  let observer;

  const textParts = element => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement?.closest(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT,
    });
    const parts = [];
    let text = '';
    while (walker.nextNode()) {
      const node = walker.currentNode;
      parts.push({node, start: text.length, end: text.length + node.length});
      text += node.data;
    }
    return {text, parts};
  };

  const point = (parts, offset) => {
    const part = parts.find(item => offset >= item.start && offset < item.end);
    return part && {node: part.node, offset: offset - part.start};
  };

  const rects = (parts, start, end) => parts.flatMap(part => {
    const from = Math.max(start, part.start);
    const to = Math.min(end, part.end);
    if (from >= to) return [];
    const range = document.createRange();
    range.setStart(part.node, from - part.start);
    range.setEnd(part.node, to - part.start);
    return [...range.getClientRects()].filter(rect => rect.width > 0 && rect.height > 0);
  });

  const keepEnding = element => {
    if (element.closest(excluded) || element.querySelector('input,textarea,select,button') ||
        element.querySelector('p,h1,h2,h3,h4,h5,h6,blockquote,li') || element.getClientRects().length === 0) return;
    const source = textParts(element);
    if (source.text.length > 2500) return;
    const match = source.text.match(/(\S+)([ \t\r\n]+)(\S+)[ \t\r\n]*$/);
    if (!match) return;
    const separatorStart = match.index + match[1].length;
    const separatorEnd = separatorStart + match[2].length;
    const first = point(source.parts, separatorStart);
    const last = point(source.parts, separatorEnd - 1);
    if (!first || !last || first.node !== last.node) return;
    const startPoint = point(source.parts, match.index);
    const endPoint = point(source.parts, separatorEnd + match[3].length - 1);
    if (!startPoint || !endPoint) return;
    const range = document.createRange();
    range.setStart(startPoint.node, startPoint.offset);
    range.setEnd(endPoint.node, endPoint.offset + 1);
    // Preserve deliberate line breaks and inline layout boundaries.
    if ([...element.querySelectorAll('br')].some(br => getComputedStyle(br).display !== 'none' && range.intersectsNode(br))) return;

    first.node.replaceData(first.offset, match[2].length, '\u00a0');
    const joined = textParts(element);
    const previousRects = rects(joined.parts, match.index, separatorStart);
    const finalRects = rects(joined.parts, separatorStart + 1, separatorStart + 1 + match[3].length);
    const previousEnd = previousRects.at(-1);
    const endingRects = previousEnd ? [previousEnd, ...finalRects] : [];
    const style = getComputedStyle(element);
    const contentWidth = element.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    const fits = endingRects.length && contentWidth > 0 &&
      Math.max(...endingRects.map(rect => rect.right)) - Math.min(...endingRects.map(rect => rect.left)) <= contentWidth + 1 &&
      Math.max(...endingRects.map(rect => rect.top)) - Math.min(...endingRects.map(rect => rect.top)) < Math.min(...endingRects.map(rect => rect.height)) * .4;
    if (fits) {
      endings.push({node: first.node, offset: first.offset, separator: match[2]});
    } else {
      // Allow wrapping when a pair genuinely cannot fit the available width.
      first.node.replaceData(first.offset, 1, match[2]);
    }
  };

  const run = () => {
    frame = 0;
    observer?.disconnect();
    for (const ending of endings) {
      if (ending.node.isConnected && ending.node.data[ending.offset] === '\u00a0') {
        ending.node.replaceData(ending.offset, 1, ending.separator);
      }
    }
    endings = [];
    const elements = new Set();
    document.querySelectorAll(scope).forEach(root => root.querySelectorAll(copy).forEach(element => elements.add(element)));
    elements.forEach(keepEnding);
    observer?.observe(document.body, {childList: true, characterData: true, subtree: true});
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(run); };
  const start = () => {
    observer = new MutationObserver(changes => {
      if (changes.some(change => (change.target.nodeType === Node.TEXT_NODE ? change.target.parentElement : change.target)?.closest(scope))) schedule();
    });
    run();
    document.fonts?.ready.then(schedule);
    window.addEventListener('resize', schedule, {passive: true});
    document.addEventListener('shopify:section:load', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
